import { hasUploadVideoCampanhaPermission } from "./can-publish-sale-campaign.js";

/** Decide se o usuário pode ver o vídeo da campanha na tela de venda. */
export function canShowCampaignVideo(permissions) {
  return (
    hasUploadVideoCampanhaPermission(permissions, "islist") ||
    hasUploadVideoCampanhaPermission(permissions, "isinsert")
  );
}
